import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { VriAPIResponse, VriAPIResult } from '../types';
import { CustomerFeature } from '../types/customer-feature.type';

export interface GetCustomerFeatureResult extends VriAPIResult {
    data?: {
        customerFeature: CustomerFeature;
    };
}

export interface GetCustomerFeatureResponse extends VriAPIResponse {
    data: {
        featureMap: CustomerFeature;
    };
}

export const getCustomerFeature = async (id: string): Promise<GetCustomerFeatureResult> => {
    const result = {} as GetCustomerFeatureResult;
    try {
        const { data: responseData } = await axios.post<GetCustomerFeatureResponse>(
            END_POINT.GET_CUSTOMER_FEATURES,
            { id },
        );
        result.data = {
            customerFeature: responseData.data.featureMap,
        };
    } catch (error) {
        result.error = error;
    }
    return result;
};
